export const SuprimentosEstoque = {
    // Letra A:
    AJUSTE_INVENTARIO: 'Ajuste de inventário',
    AJUSTE_INVENTARIO_AVISO_SEM_CUSTO: 'Produto sem custo no depósito: informe o valor unitário da sobra.',
    AJUSTE_INVENTARIO_SEM_DIFERENCA: 'A quantidade contada é igual à quantidade em estoque.',
    AJUSTE_INVENTARIO_SUCESSO: 'Ajuste de inventário concluído com sucesso!',

    // Letra B:
    // Letra C:
    CONFIRMAR_AJUSTE_INVENTARIO: 'Confirmar ajuste',
    CONFIRMAR_SAIDA_MANUAL: 'Confirmar saída manual',

    // Letra D:
    DIFERENCA_INVENTARIO: 'Diferença (contada - sistema)',
    DATA_AJUSTE: 'Data do ajuste',
    // Letra E:
    // Letra F:
    // Letra G:
    // Letra H:
    // Letra I:
    // Letra J:
    // Letra K:
    // Letra L:
    // Letra M:
    MOTIVO_AJUSTE: 'Motivo do ajuste',

    // Letra N:
    // Letra O:
    // Letra P:
    // Letra Q:
    QUANTIDADE_CONTADA: 'Quantidade contada',
    QUANTIDADE_SISTEMA: 'Quantidade no sistema',

    // Letra R:
    // Letra S:
    SAIDA_MANUAL_ESTOQUE: 'Saída manual do estoque',
    SAIDA_MANUAL_SUCESSO: 'Saída manual concluída com sucesso!',

    // Letra T:
    // Letra U:
    // Letra V:
    VALOR_UNITARIO_SOBRA: 'Valor unitário (R$)',
    // Letra X:
    // Letra Y:
    // Letra Z:
}